import { render, staticRenderFns } from "./unit_edit_list.vue?vue&type=template&id=2583cdb2&scoped=true&"
import script from "./unit_edit_list.vue?vue&type=script&lang=js&"
export * from "./unit_edit_list.vue?vue&type=script&lang=js&"
import style0 from "./unit_edit_list.vue?vue&type=style&index=0&id=2583cdb2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583cdb2",
  null
  
)

export default component.exports